export default __webpack_public_path__ + "static/media/smille.1abdab62.svg";